import { AstraDialog, AstraHeading } from '~/astra'

import { UserFeedbackForm } from './Form/UserFeedbackForm'

export type SupportView = 'bugReport' | 'helpRequest' | 'changeRequest'

const viewTitle: Record<SupportView, string> = {
    bugReport: 'Rapporter feil',
    helpRequest: 'Be om hjelp eller still spørsmål',
    changeRequest: 'Foreslå forbedring',
}

type Props = {
    onClose: () => void
    activeView: SupportView
}

export const UserSupportDialog = ({ onClose, activeView }: Props) => {
    const dialogTitle = viewTitle[activeView]

    return (
        <AstraDialog
            isOpen={true}
            onCloseDialog={onClose}
            title={dialogTitle}
            align="top"
            className="w-[min(48rem,calc(100vw-2rem))]"
            header={
                <div className="flex min-w-0 flex-1 items-center gap-2">
                    <AstraHeading as="h3" className="min-w-0 truncate">
                        {dialogTitle}
                    </AstraHeading>
                </div>
            }
        >
            <UserFeedbackForm activeView={activeView} onClose={onClose} />
        </AstraDialog>
    )
}
